module.exports = __webpack_public_path__ + "static/img/h2.104e395d.jpg";